var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import colors from '../colors';
import { typography } from './typography';
export var MuiBadge = {
    styleOverrides: {
        badge: __assign(__assign({}, typography.caption), { padding: '3px', border: "2px solid ".concat(colors.white), background: colors.grey[120], borderRadius: '50px', '&.Mui-disabled': __assign(__assign({}, typography.caption), { color: colors.grey[700] }) }),
    },
};
